import React from "react"
import { ButtonRow } from "../../../designSystem/button/ButtonRow";
import { Card, CardVariants } from "../../../designSystem/Card";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { P } from "../../../designSystem/typography/Body";
import { H2, H3 } from "../../../designSystem/typography/Heading";
import { BrutalMessageCard, CivilizedMessageCard, MessageCard } from "../../../designSystem/MessageCard";
import { CardButton } from "../../../designSystem/CardButton";
import { DesignSystemOverviewLayout, DesignSystemSection } from "../DesignSystemHelpers";
import { SimpleStatCard, StatCard, StatCardRow } from "../../../designSystem/StatCard";
import { IconWithText } from "../../../designSystem/compositeComponents/compositeIcons/IconWithText";
import { InfoCard, InfoCardRow } from '../../../designSystem/InfoCard';


export const CardsOverview = (): JSX.Element => 
{
    
    return (
     
    <DesignSystemOverviewLayout>

        <DesignSystemSection title="Message">
            <Flex flexDirection="row" gap={10} justifyContent="space-between">
                <ButtonRow variant="stretched">
                    <MessageCard variant="info">Info: Regular MessageCard with variant - info.</MessageCard>
                    <MessageCard variant='success'>Success: Regular MessageCard with variant - success.</MessageCard>
                    <MessageCard variant="warning">Alert: Regular MessageCard with variant - warning.</MessageCard>
                    <MessageCard variant="error">Error: Regular MessageCard with variant - error.</MessageCard>
                </ButtonRow>
            </Flex>

            <Flex flexDirection="row" gap={10} justifyContent="space-between">
                <ButtonRow variant="stretched">
                    <BrutalMessageCard variant="info">Info: BrutalMessageCard example content.</BrutalMessageCard>
                    <BrutalMessageCard variant='success'>Success: BrutalMessageCard example content.</BrutalMessageCard>
                    <BrutalMessageCard variant="warning">Alert: BrutalMessageCard example content.</BrutalMessageCard>
                    <BrutalMessageCard variant="error">Error: BrutalMessageCard example content.</BrutalMessageCard>
                </ButtonRow>
            </Flex>

            <Flex flexDirection="row" gap={10} justifyContent="space-between">

                <ButtonRow variant="stretched">
                    <CivilizedMessageCard variant="info">Info: CivilizedMessageCard example content.</CivilizedMessageCard>
                    <CivilizedMessageCard variant='success'>Success: CivilizedMessageCard example content.</CivilizedMessageCard>
                    <CivilizedMessageCard variant="warning">Alert: CivilizedMessageCard example content.</CivilizedMessageCard>
                    <CivilizedMessageCard variant="error">Error: CivilizedMessageCard example content.</CivilizedMessageCard>
                </ButtonRow>
            </Flex>


        </DesignSystemSection>

        <DesignSystemSection title="InfoCard">
            <InfoCardRow>
                <InfoCard
                    icon="interface_actions_edit"
                    header="Mødereferat"
                    text="Noter drøftelser og beslutninger løbende under mødet."
                />
                <InfoCard
                    icon="actions_unavailable"
                    header="Handlepunkter"
                    text="Udfald og opgaver med tildelt ansvarlig og fast deadline."
                />
                <InfoCard
                    icon="list"
                    header="Husk"
                    text="Strukturér med punktopstillinger, fed skrift og hyperlinks."
                />
            </InfoCardRow>
        </DesignSystemSection>

        <DesignSystemSection title="StatCard">
            <StatCardRow>
                <SimpleStatCard header="SimpleStatCard" stat="124" subText="With a subText" />
                <SimpleStatCard header="SimpleStatCard" stat="24" />
                <StatCard header="RegularContent"  subText="This is an example stat card">
                    <IconWithText icon="assignment"variant="success" tooltipContent="The tooltip">Some text with tooltip</IconWithText>
                </StatCard>
            </StatCardRow>
        </DesignSystemSection>
        
        <DesignSystemSection title="CardButtons">
            {CardVariants.map(variant =>
                <Flex key={variant} gap={8}>
                    
                    <CardButton variant={variant}>
                        <H3>CardButton variant: {variant}</H3>
                        <P>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                        </P>
                    </CardButton>

                    <CardButton variant={variant} disabled>
                        <H3>variant: {variant} disabled</H3>
                        <P>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                        </P>
                    </CardButton>

                </Flex>
            )}
        </DesignSystemSection>
        
        <DesignSystemSection title="Cards">
            {CardVariants.map(variant =>
                <Flex key={variant} gap={8}>
                    
                    <Card variant={variant}>
                        <H3>Card variant: {variant}</H3>
                        <P>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                        </P>
                    </Card>
                </Flex>
            )}
        </DesignSystemSection>

        



        <DesignSystemSection title="Misc Cards">
            <Flex flexDirection="row" gap={10} justifyContent="space-between">
                <Card>
                    <H3>This is a default card</H3>
                    <H3>...with just a paragraph</H3>
                    <P>
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                    </P>
                </Card>
                <Card>
                    <H2>This is a default card</H2>
                    <Card variant="outlined">
                        <H3>...with a light child card</H3>
                        <P>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                        </P>
                        <Card variant="attention">
                            <P>With an attention child card</P>
                        </Card>
                    </Card>
                </Card>
            </Flex>

            <Flex flexDirection="row" gap={10} justifyContent="space-between">
                <Card>Leggings roof party edison bulb gochujang craft beer. Fam +1 unicorn vinyl literally sriracha kickstarter keytar fanny pack echo park. Shaman kickstarter marfa polaroid. Sriracha fingerstache unicorn drinking vinegar meditation. Cloud bread synth kitsch, cold-pressed hell of artisan tumblr stumptown.</Card>
                <Card>Leggings roof party edison bulb gochujang craft beer. Fam +1 unicorn vinyl literally sriracha kickstarter keytar fanny pack echo park. Shaman kickstarter marfa polaroid. Sriracha fingerstache unicorn drinking vinegar meditation. Cloud bread synth kitsch, cold-pressed hell of artisan tumblr stumptown.</Card>
            </Flex>
        </DesignSystemSection>

        <DesignSystemSection title="Card - no padding">
            <Flex flexDirection="row" gap={10} justifyContent="space-between">
                <ButtonRow variant="stretched">
                    <Card padding="0px">Leggings roof party edison bulb gochujang craft beer. Fam +1 unicorn vinyl literally sriracha kickstarter keytar fanny pack echo park. Shaman kickstarter marfa polaroid. Sriracha fingerstache unicorn drinking vinegar meditation. Cloud bread synth kitsch, cold-pressed hell of artisan tumblr stumptown.</Card>
                    <Card padding="0px">Leggings roof party edison bulb gochujang craft beer. Fam +1 unicorn vinyl literally sriracha kickstarter keytar fanny pack echo park. Shaman kickstarter marfa polaroid. Sriracha fingerstache unicorn drinking vinegar meditation. Cloud bread synth kitsch, cold-pressed hell of artisan tumblr stumptown.</Card>
                </ButtonRow>
            </Flex>
        </DesignSystemSection>
             
    </DesignSystemOverviewLayout>
    );
}